export default __webpack_public_path__ + "static/logo-66d506f5ed711ef3a311b6301400f74d.png";